import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";
import { endpoint } from "../../../utils/constants/endpoint";

export const userProfileApi = createApi({
  reducerPath: "user-profile",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["nucleoFamiliare", "profiloUser"],
  endpoints: (builder) => ({
    getProfileUser: builder.query({
      query: () => ({
        url: "/user",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["profiloUser"],
    }),
    getGuestUser: builder.query({
      query: () => ({
        url: "/data/guest/registration?lite=true",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getDetailsFamilyUser: builder.query({
      query: () => ({
        url: "/user/details/familymembers",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["nucleoFamiliare"],
    }),
    getDetailsChildrenUser: builder.query({
      query: () => ({
        url: "/user/details/children",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["nucleoFamiliare"],
    }),
    getCities: builder.query({
      query: (param) => ({
        url: `data/guest/cities?query=${param}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    doEditProfile: builder.mutation({
      query: (body) => ({
        url: endpoint.USERS.USERS,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["profiloUser"],
    }),
    doDeleteFamily: builder.mutation({
      query: (id) => ({
        url: endpoint.USER_NUCLEO.FAMILY + "/" + id,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: id,
      }),
      invalidatesTags: ["nucleoFamiliare"],
    }),
    doDeleteChildren: builder.mutation({
      query: (id) => ({
        url: endpoint.USER_NUCLEO.CHILDREN + "/" + id,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: id,
      }),
      invalidatesTags: ["nucleoFamiliare"],
    }),

    doCreateFamily: builder.mutation({
      query: (body) => ({
        url: endpoint.USER_NUCLEO.FAMILY + "/add",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["nucleoFamiliare"],
    }),

    doCreateChildren: builder.mutation({
      query: (body) => ({
        url: endpoint.USER_NUCLEO.CHILDREN + "/add",
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["nucleoFamiliare"],
    }),

    doEditFamily: builder.mutation({
      query: (body) => ({
        url: endpoint.USER_NUCLEO.FAMILY + "/" + body.Id,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["nucleoFamiliare"],
    }),

    doEditChildren: builder.mutation({
      query: (body) => ({
        url: endpoint.USER_NUCLEO.CHILDREN + "/" + body.Id,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["nucleoFamiliare"],
    }),
  }),
});

export const {
  useGetProfileUserQuery,
  useGetGuestUserQuery,
  useGetDetailsFamilyUserQuery,
  useGetDetailsChildrenUserQuery,
  useGetCitiesQuery,
  useDoEditProfileMutation,
  useDoDeleteFamilyMutation,
  useDoDeleteChildrenMutation,
  useDoCreateChildrenMutation,
  useDoEditFamilyMutation,
  useDoEditChildrenMutation,
  useDoCreateFamilyMutation,
} = userProfileApi;
